import { render, staticRenderFns } from "./research-group-detail.html?vue&type=template&id=edc20094&scoped=true&external"
import script from "./research-group-detail.js?vue&type=script&lang=js&external"
export * from "./research-group-detail.js?vue&type=script&lang=js&external"
import style0 from "./research-group-detail.scss?vue&type=style&index=0&id=edc20094&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc20094",
  null
  
)

export default component.exports